export enum EChatMessageType {
  TEXT = "text",
}
